import { IBoardItem, IPreparedBoardItem, IPreparedBoardItems } from "./BoardItem";
import { TBoardLane } from "./BoardLane";

export const prepareBoardItems = (
    items: {
        [itemKey: string]: IBoardItem;
    },
    lanes: { [laneKey: string]: TBoardLane }
): IPreparedBoardItems => {
    const unsortedPreparedBoardItems = Object.keys(items).reduce((acc: IPreparedBoardItems, itemKey) => {
        const item = items[itemKey] as IPreparedBoardItem;
        item.itemKey = itemKey;

        if (acc.hasOwnProperty(item.lane)) {
            acc[item.lane].push(item);
        } else {
            acc[item.lane] = [item];
        }

        return acc;
    }, {});

    return Object.keys(lanes).reduce((acc: IPreparedBoardItems, laneKey) => {
        acc[laneKey] = unsortedPreparedBoardItems.hasOwnProperty(laneKey)
            ? unsortedPreparedBoardItems[laneKey].sort((a, b) => a.order - b.order)
            : [];
        return acc;
    }, {});
};
